import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomDirectionality } from './directionality.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { UserSettingsModels } from '@models/user-settings';
import { LocalStorageKeys } from '@consts/shared.const';
import { SessionStorageService } from '@ui';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {

  constructor(private translate: TranslateService,
              private overlayContainer: OverlayContainer,
              private directionality: CustomDirectionality,
              private authorizationService: AuthenticationService,
              private sessionStorageService: SessionStorageService) {
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    document.documentElement.lang = lang;
    const isRtl = lang === 'he';
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    const htmlDir = document.documentElement.getAttribute('dir');

    if (htmlDir) {
      this.overlayContainer.getContainerElement()
        .setAttribute('dir', htmlDir);
      this.directionality.setDirection(isRtl ? 'rtl' : 'ltr');
    }
  }

  initLanguage() {
    if (!this.authorizationService.isLoggedIn()) {
      const interfaceLanguage = this.sessionStorageService.getItem(LocalStorageKeys.LANGUAGE);
      this.setLanguage(interfaceLanguage ?? UserSettingsModels.DEFAULT_LANGUAGE);
    }
  }
}
